import React from 'react';
import { HeadWrapper, Title, Filter } from './Header.styles';

const Header = ({ chartTitle, children }) => {
	return (
		<HeadWrapper>
			<Title>{chartTitle}</Title>
      <Filter>{children}</Filter>
		</HeadWrapper>
	);
};

export default Header;
